import { defineNuxtRouteMiddleware, abortNavigation } from '#imports';
import { usePageContent } from '@/composables/usePageContent';

export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.client) return;

  const { handlePagePreviewAuth } = usePageContent();
  try {
    await handlePagePreviewAuth(to);
  } catch (error) {
    return abortNavigation({
      statusCode: error?.statusCode || 404,
      message: error?.data?.isTrustedMessage ? error.message : 'Page not found',
    });
  }
});
